import React from "react";
import { Linking, Platform, StyleSheet, Text } from "react-native";
import { FaqLink, LinkedTextProps } from "../custom-drawer/CustomDrawerTypes";
import { COLORS } from "src/theme/constants";
import { theme } from "src/theme/theme";

export const LinkedText: React.FC<LinkedTextProps> = ({
  text,
  links = [],
  textStyle,
  linkStyle,
  onNavigate,
}) => {
  if (!links.length) {
    return <Text style={textStyle}>{text}</Text>;
  }

  const handlePress = (link: FaqLink, onNavigate?: (href: string) => void) => {
    switch (link.type) {
      case "phone":
      case "email":
        Linking.openURL(link.href);
        break;
      case "navigation":
        onNavigate?.(link.href); // e.g. navigate to a tab/screen by name
        break;
    }
  };

  // Find each link's position inside the text
  type Match = { start: number; end: number; link: FaqLink };
  const matches: Match[] = [];

  links.forEach((link) => {
    const start = text.indexOf(link.identifier);
    if (start !== -1) {
      matches.push({ start, end: start + link.identifier.length, link });
    }
  });

  // Sort by position so we can slice left-to-right
  matches.sort((a, b) => a.start - b.start);

  const parts: React.ReactNode[] = [];
  let lastIndex = 0;

  matches.forEach((m, i) => {
    if (m.start > lastIndex) {
      parts.push(text.slice(lastIndex, m.start));
    }

    parts.push(
      <Text
        key={`${m.link.identifier}-${i}`}
        style={linkStyle ?? styles.link}
        onPress={() => handlePress(m.link, onNavigate)}
      >
        {m.link.identifier}
      </Text>,
    );

    lastIndex = m.end;
  });

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return <Text style={textStyle}>{parts}</Text>;
};

const styles = StyleSheet.create({
  faqQuestionContainer: {
    marginBottom: theme.margin.md,
  },
  rowApart: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  faqQuestionTxt: {
    fontSize: theme.fontsize.cs,
    fontWeight: theme.fontweight.medium,
  },
  faqAnswerTxt: {
    fontSize: theme.fontsize.reg,
    marginTop: theme.margin.sm,
    lineHeight: theme.radius.mmd,
  },
  faqDropdownCollapsedIcon: {
    width: theme.spacing.md,
    height: theme.spacing.md,
  },
  link: {
    color: theme.colors.secondary,
    textDecorationLine: "underline",
    fontWeight:theme.fontweight.regular,
    ...(Platform.OS === "web" ? ({ cursor: "pointer" } as any) : {}),
  },
});
